export const IMAGE_ACCEPT = {
  "image/jpeg": [],
  "image/png": [],
  "image/webp": [],
  "image/avif": [],
  "image/heic": [],
  "image/heif": [],
} as const;

export const IMAGE_AND_PDF_ACCEPT = {
  ...IMAGE_ACCEPT,
  "application/pdf": [".pdf"],
} as const;
